module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.6-216.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.1-rc.6.md
// module id = 657
// module chunks = 341